<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the switch"
      [formField]="configForm.helpText" />
    <lib-signal-checkbox
      label="Default value"
      hint="Automatically filled when the form opens. Respondents can change it."
      [formField]="configForm.defaultValue" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must turn this option on"
      [formField]="configForm.required" />
  </section>
</form>
